import React, { useEffect, useRef } from "react";
import { Select, Avatar, message, Popover, Tooltip, Dropdown, Spin, Switch } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { FontIcon } from "@fluentui/react";
import "./MainChatPlatformPage.css";
import ChatInput from "../../components/MainChatPlatformComponent/ChatInputComponent/ChatInput";
import ChatContainerComponent from "../../components/MainChatPlatformComponent/ChatContainerComponent/ChatContainerComponent";
import { useSelector } from "react-redux";
import InitialChatContainer from "../../components/MainChatPlatformComponent/InitialChatContainer/InitialChatContainer";
import SourceContainerComponent from "../../components/MainChatPlatformComponent/SourceContainerComponent/SourceContainerComponent";
import { RootState } from "../../redux/store";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { closeSourceDetail, fetchSuggestQuestion } from "../../redux/EngageGPT/EngageGPTAction";
import LoadingPage from "../template/LoadingPage/LoadingPage";

export interface LivePlatformPageProps {}

function MainChatPlatformPage(props: any) {
  const chatContainerRef = useRef(null) as any;
  const chatAiState = useSelector((state: RootState) => state.engageGPTState.chatAIMainState);
  const dispatch = useAppDispatch();
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatAiState.messages]);
  useEffect(() => {
    dispatch(fetchSuggestQuestion({}));
  }, []);
  if (chatAiState.initialLoading) {
    return <LoadingPage />;
  }
  return (
    <div className="d-flex w-100 h-100 overflow-hidden">
      <div
        className="body-container "
        ref={chatContainerRef}>
        <div className="position-relative  h-100 d-flex flex-column full-flex ">
          {chatAiState.messages.length <= 0 ? <InitialChatContainer suggestedQuestions={chatAiState.suggestedQuestions} /> : <ChatContainerComponent messages={chatAiState.messages} />}

          {/* {chatAiState.loading && (
              <div className="stop-btn-container">
                <button
                  onClick={() => {
                    controller.abort();
                    setLoading(false);
                  }}>
                  Stop generating
                </button>
              </div>
            )} */}
          <ChatInput chatContainerRef={chatContainerRef} />
        </div>
      </div>
      {chatAiState.sourceDetailOpenState && <SourceContainerComponent close={() => dispatch(closeSourceDetail())} />}
    </div>
  );
}

export default MainChatPlatformPage;
